module Cfnc.Security {
    export class CfncStorage {
        public static userName: string = "userInfo.userName";
        public static firstName = "userInfo.firstName";
        public static lastName: string = "userInfo.lastName";
        public static fullName: string = "userInfo.fullName";
        public static tenant: string = "userInfo.tenant";
        public static loginProvider: string = "userInfo.loginProvider";
        public static hasRegistered: string = "userInfo.hasRegistered";
        public static timeZone: string = "userInfo.timeZone";
        public static primaryConnection: string = "userInfo.PrimaryConnection";
        public static accessToken: string = "accessToken";
        public static refreshToken: string = "refreshToken";
        public static expiresOn: string = "expiresOn";
        public static redirectTarget: string = "redirectTarget";
        public static rememberMe: string = "rememberMe";
        public static refreshTokenExpiresIn: string = "refreshTokenExpiresIn";
    }
} 